import React from 'react';

import PublishNotificationUI from './publish_notification.ui.jsx';

export default () => (
  <PublishNotificationUI
    title="A new version of this template was created. This version can be used to create sites."
  />
);
